import SettingBase from '../settings/util/SettingBase'

class BranchFundingSourceController extends SettingBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'branch-funding-source'
    this.$state = $state
    this.hasACL = {}
  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['setting-branch-funding-source']) {
      this.hasACL[this.acl['setting-branch-funding-source'][key]] = true;
    }
  }
}

export default BranchFundingSourceController;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/branch_funding_source.controller.js